import styled from "styled-components";
import Colors from "../../constants/Colors";
import {deviceMax, deviceMin} from "../../../styles/device";

export const MobileAppWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  background-color: ${Colors.white};
  border-radius: 6px;
  margin: 26px 20px;

  @media ${deviceMax.tablet} {
    flex-direction: column;
    margin-top: 0;
    margin-bottom: 0;
    padding-bottom: 30px;
  }
`;

export const MobileAppRow = styled.div`
  position: relative;
  flex: 1;

  @media ${deviceMax.tablet} {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  > .store-and-qr-section {
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    padding-top: 23px;
    padding-bottom: 20px;
    padding-right: 56px;

    @media ${deviceMin.laptop} and ${deviceMax.laptopL} {
      flex-direction: row;
    }
    
    @media ${deviceMax.tablet} {
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding-top: 0;
      padding-bottom: 0;
      padding-right: 0;
    }

    > .store {
      position: relative;
      display: flex;
      flex-direction: column;
      margin-right: 50px;

      @media ${deviceMax.laptop} {
        margin-right: 0;
        margin-bottom: 22px;
      }

      > a {
        margin-bottom: 22px;

        @media ${deviceMax.tablet} {
          max-width: 180px;
        }

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    > .qr {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      background: ${Colors.white};
      border-radius: 20px;
      padding: 14px;
      max-width: 156px;
      max-height: 156px;

      @media ${deviceMin.laptop} and ${deviceMax.laptopL} {
        max-width: 140px;
        max-height: 140px;
      }

      @media ${deviceMax.tablet} {
        padding: 10px;
      }

      > .qr-background-gradient {
        display: flex;
        border-radius: 20px;
        background-image: linear-gradient(to bottom, #2ed3e1, #27cfe0, #1fcbe0, #18c7df, #10c3de, #09bfdc, #04bad9, #00b6d7, #00b0d3, #00abd0, #00a5cc, #00a0c8);

        > canvas {
          position: relative;
          z-index: 2;
          padding: 14px;

          @media ${deviceMin.laptop} and ${deviceMax.laptopL} {
            max-width: 112px;
            max-height: 112px;
          }

          @media ${deviceMax.tablet} {
            max-width: 112px;
            max-height: 112px;
          }

        }
      }

    }

  }
`;

export const MobileAppTitle = styled.h1`
  position: relative;
  font-weight: 800;
  font-size: 18px;
  line-height: 55px;
  letter-spacing: 0;
  text-transform: uppercase;
  color: ${Colors.brandColor};
  margin: 20px 0 0 56px;

  @media ${deviceMax.tablet} {
    color: ${Colors.black};
    margin-left: 0;
  }
`;

export const MobileAppText = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  margin-top: 26px;
  padding-right: 46px;
  padding-left: 56px;
  padding-bottom: 32px;
  box-sizing: border-box;

  @media ${deviceMax.tablet} {
    flex-direction: column;
    margin-top: 0;
    padding-right: 0;
    padding-left: 0;
  }

  p {
    position: relative;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: 0;
    color: ${Colors.black};
    margin: 0;

    @media ${deviceMax.tablet} {
      margin-top: 16px;
      padding-left: 39px;
      padding-right: 34px;
      text-align: center;
      margin-top: 10px;
    }
  }
`;

